<template>
    <div>
         <con-tab @TwoClick="TwoClick"></con-tab>
       <!-- 服务商主页 -->
        <Service-Nei ></Service-Nei>
    </div>
</template>

<script>
    import ConTab from "../../components/common/ConTab";
    import ServiceNei from "./base/ServiceNei";
    // import Qs from 'qs'
    export default {
        name: "Service",
        data(){
            return {
                
            }
        },
        created(){
            
        },
        methods:{
             TwoClick(item){
                //console.log(item);
                this.ConList = item
            },
        },
        components:{
            ConTab,
            ServiceNei
        }
    }
</script>

<style scoped>

</style>
